import { cn } from "@/lib/utils";

export type UseCaseItem = {
  title: string;
  body: string;
};

type UseCaseListProps = {
  items: UseCaseItem[];
  className?: string;
};

export function UseCaseList({ items, className }: UseCaseListProps) {
  return (
    <ul className={cn("space-y-12", className)}>
      {items.map((item) => (
        <li key={item.title} className="flex flex-col gap-3 sm:flex-row sm:gap-12">
          <span className="font-mono text-sm uppercase tracking-widest text-muted-foreground sm:w-56 shrink-0">
            {item.title}
          </span>
          <p className="text-foreground/90 leading-relaxed">{item.body}</p>
        </li>
      ))}
    </ul>
  );
}
